import Link from 'next/link';
import { forwardRef } from 'react';

interface SuperLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  useAnchor?: boolean;
}

export const SuperLink = forwardRef<HTMLAnchorElement, SuperLinkProps>(
  ({ href, useAnchor, ...props }, ref) => {
    if (useAnchor) {
      return <a href={href} {...props} ref={ref} />;
    }

    // @ts-expect-error typed routes
    return <Link href={href || ''} {...props} ref={ref} passHref />;
  },
);
